<template>
    <div class="update-location">
        <form-component ref="form" class="update-location-page container" v-if="!locationUpdated">
            <div class="row">
                <div class="col">
                    <div class="box">
                      <p v-if="locationDeleteErrorMessage">{{ locationDeleteErrorMessage }}</p>
                        <h4>Woonlocatie gegevens</h4>
                        <p v-if="locationNameErrorMessage" class="errorMessage">{{ locationNameErrorMessage }}</p>
                        <input-component type="text" label="Naam" v-model="locationToEdit.locationName"></input-component>
                        <p v-if="streetNameErrorMessage" class="errorMessage">{{ streetNameErrorMessage }}</p>
                        <input-component type="text" label="Straatnaam" v-model="locationToEdit.streetName"></input-component>
                        <p v-if="streetNumberErrorMessage" class="errorMessage">{{ streetNumberErrorMessage }}</p>
                        <input-component type="number" label="Huisnummer" v-model="locationToEdit.streetNumber"></input-component>
                        <p v-if="postalCodeErrorMessage" class="errorMessage">{{ postalCodeErrorMessage }}</p>
                        <input-component type="text" label="Postcode" v-model="locationToEdit.postalCode"></input-component>
                        <p v-if="cityErrorMessage" class="errorMessage">{{ cityErrorMessage }}</p>
                        <input-component type="text" label="Plaatsnaam" v-model="locationToEdit.city"></input-component>
                        <p v-if="phoneNumberErrorMessage" class="errorMessage">{{ phoneNumberErrorMessage }}</p>
                        <input-component type="text" label="Telefoonnummer" v-model="locationToEdit.phoneNumber"></input-component>
                        <input-component type="text" label="Telegram group ID" v-model="locationToEdit.telegramGroupId"></input-component>

                        <input-component type="string" step="any" label="GPS locatie (lat)" v-model="locationToEdit.gpsLocationLat"></input-component>
                        <input-component type="string" step="any" label="GPS locatie (lng)" v-model="locationToEdit.gpsLocationLng"></input-component>

                      <label for="isSmsServiceActivated">SMS berichten service</label>
                      <label class="checkbox-container">
                        <input type="checkbox"
                               id="isSmsServiceActivated"
                               v-model="locationToEdit.smsServiceActivated"
                               :checked="locationToEdit.smsServiceActivated">
                        <span class="checkmark"></span>
                      </label>
                    </div>

                </div>

                <div class="col">
                    <div class="box">
                        <h4>Bellen bij geen gehoor</h4>
                        <div class="add-contacts">
                            <div :key="i" v-for="(contact, i) in locationToEdit.contacts">
                                <p @click="removeContact(i)">X</p>
                                <p v-if="!contactIsValid(contact)" class="errorMessage">{{ contactIsInvalidErrorMessage }}</p>
                                <input-component required="required" label="Naam" v-model="contact.contactName"></input-component>
                                <input-component required="required" label="Nummer" v-model="contact.phoneNumber"></input-component>
                                <hr>
                            </div>
                            <button
                                    ref="addButton"
                                    class="add-button"
                                    @click="addContact"
                            >+</button>
                        </div>
                    </div>
                </div>
            </div>
            <button-component @click.native="updateLocation">Opslaan</button-component>
            <button-component
                    variant="error"
                    @click.native="showModal">
                Verwijderen
            </button-component>
        </form-component>

        <div class="location-created" v-if="locationUpdated">
            <div class="complete-image"></div>
            <p class="complete-title">Locatie {{ this.locationToEdit.locationName }} gewijzigd, u wordt teruggestuurd naar het overzicht</p>
            <circle-component position="bottom-center" height=236 />
        </div>

        <Modal v-show="isModalVisible"
               @close="closeModal"
               v-bind:header="modalHeaderText"
               v-bind:body="modalBodyText"
               v-bind:buttonLeft="modalButtonLeft"
               v-bind:buttonRight="modalButtonRight"
               @onDeleteClicked="deleteLocation"
        >
        </Modal>
    </div>
</template>

<script>
import { RouteName } from '../../utils/enums';
import ButtonComponent from '../../components/button.component.vue';
import FormComponent from '../../components/fields/form.component.vue';
import InputComponent from '../../components/fields/input.component.vue';
import CircleComponent from '@/components/circle.component.vue';
import Modal from '../../components/modal.component.vue';
import { Location } from '../../domain/location';
import { isValidZipcode, isValidPhoneNumber, lastContactIsValid } from '../../utils/validators';

export default {
    name: 'admin-locations-edit-page',
    components: {
        FormComponent,
        InputComponent,
        ButtonComponent,
        CircleComponent,
        Modal
    },
    data() {
        return {
            locationToEdit: Location,
            locationUpdated: false,
            locationNameErrorMessage: null,
            streetNameErrorMessage: null,
            streetNumberErrorMessage: null,
            postalCodeErrorMessage: null,
            cityErrorMessage: null,
            phoneNumberErrorMessage: null,
            contactIsInvalidErrorMessage: null,
            modalHeaderText: 'Woonlocatie verwijderen',
            modalBodyText: 'Weet u zeker dat u de woonlocatie wilt verwijderen?',
            modalButtonLeft: 'Annuleren',
            modalButtonRight: 'Verwijderen',
            isModalVisible: false,
            locationDeleteErrorMessage: null
        };
    },
    created() {
        this.locationToEdit = this.$store.getters.getLocationToEdit;
    },
    methods: {
        formIsValid: function() {
            !this.locationToEdit.locationName ? this.locationNameErrorMessage = 'Naam is verplicht' : this.locationNameErrorMessage = null;
            !this.locationToEdit.streetName ? this.streetNameErrorMessage = 'Straatnaam is verplicht' : this.streetNameErrorMessage = null;
            !this.locationToEdit.streetNumber ? this.streetNumberErrorMessage = 'Huisnummer is verplicht' : this.streetNumberErrorMessage = null;
            !isValidZipcode(this.locationToEdit.postalCode) ? this.postalCodeErrorMessage = 'Postcode is niet geldig' : this.postalCodeErrorMessage = '';
            !this.locationToEdit.city ? this.cityErrorMessage = 'Plaatsnaam is verplicht' : this.cityErrorMessage = '';
            !isValidPhoneNumber(this.locationToEdit.phoneNumber) ? this.phoneNumberErrorMessage = 'Telefoonnummer is niet geldig (0031)' : this.phoneNumberErrorMessage = '';
            !lastContactIsValid(this.locationToEdit.contacts) ? this.contactIsInvalidErrorMessage = 'Contact is niet juist ingevoerd' : this.contactIsInvalidErrorMessage = null;

            return !this.locationNameErrorMessage &&
                !this.streetNameErrorMessage &&
                !this.streetNumberErrorMessage &&
                !this.postalCodeErrorMessage &&
                !this.cityErrorMessage &&
                !this.phoneNumberErrorMessage &&
                !this.contactIsInvalidErrorMessage;
        },
        addContact: function() {
            if (lastContactIsValid(this.locationToEdit.contacts)) {
                this.locationToEdit.contacts.push({
                    contactName: '',
                    phoneNumber: ''
                });
            }
            // Scroll a bit down so the user can add multiple contacts quickly
            this.$refs.addButton.scrollIntoView();
        },
        contactIsValid: function(contact) {
            return contact.contactName.length > 0 && contact.phoneNumber.length >= 3;
        },
        removeContact(index) {
            this.locationToEdit.contacts.splice(index, 1);
        },
        updateLocation() {
            if (this.formIsValid()) {
                this.$store.dispatch('UPDATE_LOCATION', this.locationToEdit)
                    .then(response => {
                        if (response.status === 200) { // updated, show confirmation
                            this.locationUpdated = true; // redirect back after 2 seconds
                            setTimeout(() => {
                                this.$router.push({name: RouteName.ADMIN_LOCATIONS});
                            }, 2500);
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    })
            }
            else {
                console.error('Niet alle velden zijn juist ingevoerd');
            }
        },
        deleteLocation: function () {
            this.closeModal();
            this.$store.dispatch('DELETE_LOCATION', this.locationToEdit.id)
                .then(response => {
                    if (response.status === 200) {
                        this.$router.push({ name: RouteName.ADMIN_LOCATIONS });
                    }
                    if (response.status === 400) {
                      this.locationDeleteErrorMessage = response.data;
                      window.scrollTo(0 ,0);
                    }
                })
        },
        showModal() {
            this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
        }
    }
};
</script>

<style scoped lang="scss">
    .row {
        flex-direction: column;

        @include desktop {
            flex-direction: row;
        }
    }

    .box {
        margin-bottom: 2rem;

        @include desktop {
            background-color: $white;
            // height: 100%;
            padding: 1rem;
            box-shadow: 0 -2px 8px 0px rgba(0, 0, 0, 0.1);
            border-radius: 0.25rem;
        }

        h4 {
            font-weight: 400;
            margin-bottom: 1rem;
            color: $gray-darkest;
        }

        .errorMessage {
            color: red;
            font-size: small;
            font-weight: normal;
        }

        p {
            color: red;
            font-weight: bold;
            margin-bottom: 0px;

            &:hover {
                cursor: pointer;
            }
        }
    }

    .add-contacts {
        border-radius: 4px;
        border: 1px solid $gray;
        padding: 1rem;
        position: relative;
        margin-bottom: 1rem;

        .add-button {
            $button-size: 42px;
            position: absolute;
            bottom: -($button-size / 2);
            left: 50%;
            margin-left: -($button-size / 2);
            width: $button-size;
            height: $button-size;
            border-radius: 50%;
            background-color: $primary;
            color: $white;
            font-weight: bold;

            &:hover {
                background-color: $lightGreen;
            }
        }
    }

    .subtitle {
        margin: 1rem 0;
        display: block;
        font-weight: 500;
    }

    .seperator {
        margin: 2rem 0;
        background-color: $gray;
    }

    .input-component,
    .switch-component {
        margin-bottom: 1rem;
    }

    .row-wrapper {
        display: flex;

        .input-component {
            flex-grow: 1;

            &:first-child {
                margin-right: 60px;
            }
        }
    }

    .smartwatch-bg-color {
        margin-bottom: 1rem;
    }
    .location-created {
        height: 100%;
        background-color: $primary;
        color: $white;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .complete-title {
            margin-bottom: 14px;
        }

        p {
            font-size: 16px;
            text-align: center;
        }
    }

    .complete-image {
        width: 95px;
        height: 120px;
        background-image: url('../../assets/icons/watch-large-complete.svg');
        margin-bottom: 64px;
        margin-top: -60px;
    }
</style>
